import React from "react";
import { useSearchParams } from "react-router-dom";
import AppShell from "../components/AppShell";
import QuillaIA from "../components/QuillaIA";
import DashboardTab from "../components/gerencia/DashboardTab";
import BriefingTab from "../components/gerencia/BriefingTab";
import WeatherTab from "../components/gerencia/WeatherTab";
import SargassumTab from "../components/gerencia/SargassumTab";
import PreventiveTab from "../components/gerencia/PreventiveTab";
import StructureTab from "../components/gerencia/StructureTab";
import CatalogTab from "../components/gerencia/CatalogTab";
import HistorialTab from "../components/gerencia/HistorialTab";
import UsersTab from "../components/gerencia/UsersTab";
import { SealCheck, Sparkle, ChatCircle, Wind, Waves, CalendarBlank, Buildings, Users, Wrench, ClockCounterClockwise } from "@phosphor-icons/react";

const TABS = [
  { id: "dashboard",  label: "Panel",           Ic: SealCheck },
  { id: "ia",         label: "QUILLA IA",       Ic: Sparkle },
  { id: "briefing",   label: "Parte matutino",  Ic: ChatCircle },
  { id: "clima",      label: "Clima",           Ic: Wind },
  { id: "sargazo",    label: "Sargazo",         Ic: Waves },
  { id: "preventivo", label: "Preventivo",      Ic: CalendarBlank },
  { id: "catalogo",   label: "Catálogo",        Ic: Wrench },
  { id: "historial",  label: "Historial",       Ic: ClockCounterClockwise },
  { id: "estructura", label: "Estructura",      Ic: Buildings },
  { id: "usuarios",   label: "Usuarios",        Ic: Users },
];

export default function Management() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "dashboard";
  const setTab = (t) => setParams({ tab: t });
  return (
    <AppShell title="Panel de Gerencia">
      <div className="flex gap-1 md:gap-2 overflow-x-auto mb-6 pb-2 -mx-4 md:mx-0 px-4 md:px-0">
        {TABS.map(t => {
          const TIc = t.Ic;
          const active = tab === t.id;
          return (
            <button key={t.id} data-testid={"tab-" + t.id} onClick={() => setTab(t.id)}
                    className={"flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition " + (active ? "bg-[color:var(--q-navy)] text-white" : "bg-white border border-[color:var(--q-border)] hover:border-[color:var(--q-navy)]")}>
              <TIc size={14} weight={active ? "fill" : "regular"}/> {t.label}
            </button>
          );
        })}
      </div>
      {tab === "dashboard"  && <DashboardTab/>}
      {tab === "ia"         && <div className="max-w-4xl"><QuillaIA context="gerencia"/></div>}
      {tab === "briefing"   && <BriefingTab/>}
      {tab === "clima"      && <WeatherTab/>}
      {tab === "sargazo"    && <SargassumTab/>}
      {tab === "preventivo" && <PreventiveTab/>}
      {tab === "catalogo"   && <CatalogTab/>}
      {tab === "historial"  && <HistorialTab/>}
      {tab === "estructura" && <StructureTab/>}
      {tab === "usuarios"   && <UsersTab/>}
    </AppShell>
  );
}
